export default __webpack_public_path__ + "static/media/podolsk_zudin.f19a781f.jpg";